import React from "react";
import { Paper, Grid, Box, useTheme, Typography } from "@mui/material";
import { LocationOn, Cloud, DeviceThermostat } from "@mui/icons-material";
import ParameterItem from "./ParameterItem";
import SectionHeader from "./SectionHeader";
import { useAuth } from "../../../AuthContext";
import IndiaPumpMap from "../../../components/IndiaPumpMap";

const LocationSection = ({ sx }) => {
  const { pumpStats } = useAuth();
  const theme = useTheme();

  //if (!pumpStats?.pump_info?.geolocation) return null;
//console.log('this location section ran again')
  return (
    <Paper
      sx={{
        borderRadius: theme.shape.borderRadius * 2,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        ...sx,
      }}
    >
      <SectionHeader icon={<LocationOn fontSize="small" />} title="Location" />

      <Grid
        container
        spacing={1.5}
        sx={{
          p: 2,
          flex: 1,
          alignContent: "flex-start",
        }}
      >
        {/* <ParameterItem icon={<LocationOn />} name="Latitude" value={pumpStats.pump_info.geolocation[0]} />
        <ParameterItem icon={<LocationOn />} name="Longitude" value={pumpStats.pump_info.geolocation[1]} />
        <ParameterItem icon={<Cloud />} name="Weather" value="Sunny" />
        <ParameterItem icon={<DeviceThermostat />} name="Temperature" value="32°C" /> */}

        <Grid item xs={12} sx={{ mt: "auto" }}>
          {pumpStats?.pump_info?.geolocation ? (
            <Box sx={{ height: 500}}>
              <IndiaPumpMap singlePumpLocation={{
        "geo_location": pumpStats?.pump_info?.geolocation ,
        "imei": pumpStats?.pump_status?.imei ,
        "pump_online": pumpStats?.pump_status?.pump_connectivity
    }}/>
            </Box>
          ) : (
            <Box
              sx={{
                height: 200,
                minHeight: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f9f9f9", // optional light background for better contrast
                borderRadius: 2, // optional rounded corners
              }}
            >
              <Typography
                variant="h6" // bigger and bold
                align="center"
                sx={{ fontWeight: 500, color: "#555",fontSize:'1.3rem' }}
              >
                Pump yet to be fully commissioned. No Location Data available.
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default React.memo(LocationSection);
